// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted

/**
 * Returns an absolute URL to create a new company.
 *
 * @param name - The name of the new company.
 */
export function getNewCompanyURL(
  name: string,
  isCustomer?: boolean,
  isSupplier?: boolean
) {
  // Default to the companies page
  let url = new URL('/companies', document.location.origin);

  // If both are true, redirect to the companies page
  if (isCustomer === true && isSupplier === true) {
    url = new URL('/companies', document.location.origin);
    // If only customer is true, redirect to the customers page
  } else if (isCustomer === true) {
    url = new URL('/companies/customers', document.location.origin);
    // If only supplier is true, redirect to the suppliers page
  } else if (isSupplier === true) {
    url = new URL('/companies/suppliers', document.location.origin);
  }

  url.searchParams.append('new', encodeURIComponent(name));

  return url;
}
